// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__q6mgd","timezone":"styles_timezone__HpcvH","header":"styles_header__698cf","text_wrapper":"styles_text_wrapper__G4C4B","content":"styles_content__2IkJ0"};